module.exports = __webpack_public_path__ + "static/media/trigo.362af5aa.png";